<template>
    <div class="box plan-box">
        <p class="small-box-title">
            Your Plan
            <span
                v-if="userSubscriptionDetails.endsAt"
                class="coupon-code"
            >
                cancelled
            </span>
        </p>
        <transition
            name="fade"
            mode="out-in"
        >
            <div
                v-if="isLoading"
                class="loader"
            >
                <i class="fas fa-spinner fa-spin loader" />
            </div>
            <div
                v-else
                class="plan-info"
            >
                <div class="plan-details">
                    <span class="plan-name">Fusebox Pro {{ planName }}</span>
                    <span class="plan-websites">({{ quantity }})</span>
                </div>
                <span
                    v-if="!userSubscriptionDetails.couponCode"
                    class="plan-cost"
                >
                    {{ cost }} <span class="plan-cost-suffix">/ mo</span>
                </span>
                <span
                    v-else
                    class="plan-cost plan-cost-discount"
                >
                    <strike>{{ basePlanPrice | billingPlanFilter }}</strike>
                    {{ cost }} <span class="plan-cost-suffix">/ mo</span>
                </span>
                <template v-if="showLinks">
                    <a
                        v-if="!userSubscriptionDetails.endsAt"
                        class="link"
                        href="#"
                        @click.prevent="openUpgradeModal"
                    >
                        Update Your Plan
                    </a>
                    <a
                        v-else
                        class="link"
                        href="#"
                        @click.prevent="openResumeSubscriptionModal"
                    >
                        Resume Your Subscription
                    </a>
                </template>

                <span
                    v-if="userSubscriptionDetails.couponCode && false"
                    class="plan-discount"
                >
                    Coupon code: <span class="coupon-code">{{ userSubscriptionDetails.couponCode }}</span>
                        <template v-if="userSubscriptionDetails.couponPercent">
                            {{ userSubscriptionDetails.couponPercent }}%
                        </template>
                        <template v-else>
                            {{ priceInUsd( userSubscriptionDetails.couponAmount ) }}
                        </template>
                        off
                </span>
            </div>
        </transition>
        <new-app-prompt v-if="! isMigratedUser" />
    </div>
</template>

<script>
import {
    mapGetters,
    mapMutations,
    mapState,
} from 'vuex';
import usdFormatter from '@/utils/usdFormatter';
import { billingPlanFilter } from '@/utils/filters';
import NewAppPrompt from './NewAppPrompt';

export default {
    components: {
        NewAppPrompt,
    },

    computed: {
        ...mapState([
            'currentSubscription',
            'userSubscription',
            'user',
        ]),
        ...mapGetters(['userSubscriptionDetails']),

        /**
         * @returns {boolean} Whether the subscription is loading.
         */
        isLoading() {
            return null === this.userSubscriptionDetails;
        },

        /**
         * @returns {string} Plan name.
         */
        planName() {
            // Lifetime plan name for lifetime subscriptions without stripe_id
            if ('Free' === this.userSubscriptionDetails?.nickname) {
                return '';
            } else {
                return this.userSubscriptionDetails?.nickname;
            }
        },

        /**
         * @returns {string} Sites quantity.
         */
        quantity() {
            const quantity = this.userSubscriptionDetails.quantity || 1;

            return `${quantity} ${this.sitesSuffix(quantity)}`;
        },

        /**
         * @returns {boolean} Whether to show links.
         */
        showLinks() {
            return this.isMigratedUser && 'lifetime' !== this.currentSubscription.name;
        },

        /**
         * @returns {string} Plan cost.
         */
        cost() {
            return this.userSubscriptionDetails.amount
                ? billingPlanFilter(this.userSubscriptionDetails)
                : usdFormatter(0);
        },

        /**
         * Plan price without discount
         *
         * @returns {object} Plan with amount multiplied by number of sites.
         */
        basePlanPrice() {
            const basePlan = { ...this.userSubscriptionDetails.subscriptionDetails.plan };

            basePlan.amount = basePlan.amount * this.userSubscription.quantity || 1;

            return basePlan;
        },

        /**
         * Check if user is migrated
         *
         * @returns  {boolean}  If user was migrated
         */
        isMigratedUser() {
            return ! this.user.migrated;
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Suffix sites cunter
         *
         * @param {number} quantity Number of sites
         * @returns  {string}  Number suffix
         */
        sitesSuffix(quantity) {
            return 1 === quantity ? 'Site' : 'Sites';
        },

        /**
         * Opens upgrade modal
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeProModalVisible: true });
        },

        /**
         * Opens resume subscription modal
         */
        openResumeSubscriptionModal() {
            this.changeUIState({ isResumeSubscriptionModalVisible: true });
        },

        /**
         * Returns number formatted in USD
         *
         * @param {number} amount Amount in cents.coupon-btn
         *
         * @returns {string} Price in USD format.
         */
        priceInUsd(amount) {
            return usdFormatter(amount);
        },
    },
};
</script>
